export default __webpack_public_path__ + "assets/img/logosreeyapng.39fc090e85d2781f1bc6627e60ba2484.png";